"use client";

import React from "react";
import { Search, Ruler, Cpu, Bug, Blocks, Rocket, Wrench, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  id: 1,
  title: "Briefing Estratégico",
  icon: Search
}, {
  id: 2,
  title: "Roteirização e Pré",
  icon: Ruler
}, {
  id: 3,
  title: "Produção e Gravação",
  icon: Cpu
}, {
  id: 4,
  title: "Edição e Finalização",
  icon: Bug
}, {
  id: 5,
  title: "Otimização de SEO",
  icon: Blocks
}, {
  id: 6,
  title: "Distribuição Digital",
  icon: Rocket
}, {
  id: 7,
  title: "Análise de Métricas",
  icon: Wrench
}, {
  id: 8,
  title: "Escala de Resultados",
  icon: TrendingUp
}];
export default function TechnologicalCycle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}